import React, { PureComponent } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import styles from './styles.scss';

export default class Image extends PureComponent {
  static propTypes = {
    src: PropTypes.string.isRequired,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    tinySrc: PropTypes.string,
    alt: PropTypes.node,
    className: PropTypes.string,
  };

  static defaultProps = {
    className: '',
  };

  state = {
    isLoaded: false,
  };

  renderLoadingState = () => {
    const { height, width, className, alt, tinySrc } = this.props;

    if (tinySrc) {
      return (
        <img
          className={`${styles.img} ${className} ${styles.placeholderImage}`}
          ref={(img) => (this.img = img)}
          height={height}
          width={width}
          src={tinySrc}
          alt={alt}
        />
      );
    }

    // if there is not tinySrc display spinner till the image is loaded
    return (
      <div className={styles.spinner} style={{ height, width }}>
        <i className="fa fa-loading fa-spin" />
      </div>
    );
  };

  render() {
    const { height, width, className, src, alt } = this.props;
    const { isLoaded } = this.state;

    return (
      <>
        {!isLoaded && this.renderLoadingState()}
        <img
          className={classnames(styles.img, className, styles.loaded, { [styles.show]: isLoaded })}
          height={height}
          src={src}
          onLoad={() => this.setState({ isLoaded: true })}
          width={width}
          alt={alt}
        />
      </>
    );
  }
}
